import React, {PureComponent} from "react";
import {MfaApplications} from "../util/mfa_applications";
import {Heading, Paper} from "@hawkins/components";
import {QueryStatus, SearchBar} from "@hawkins/search";
import {searchUsers} from "../api/mgmt";
import {User} from "../api/types";
import {Table, TypeColumn} from "@hawkins/table";
import {Link} from "react-router-dom";

interface State {
    currentSearch?: string
    users?: User[]
    searchStatus?: QueryStatus
}

export interface Props {
    mfaApplications: MfaApplications
}

export default class Home extends PureComponent<Props, State> {
    state: State = {};

    render() {
        const columns: TypeColumn[] = [
            {
                flex: 6, header: 'User Name', name: 'userName',
                render: ({data}) => <Link to={`/${data.domain}/${data.userName}`}>{data.userName}</Link>
            },
            { flex: 4, header: 'Domain', name: 'domain' },
            { flex: 2, header: 'MFA Application', name: 'mfaApplication' },
        ];

        const dataSource = [];
        if (this.state.users) {
            for (let user of this.state.users) {
                dataSource.push({
                    userName: user.userName,
                    domain: user.domain,
                    mfaApplication: this.props.mfaApplications.getMfaApplication(user.mfaApplicationId)?.name || user.mfaApplicationId,
                });
            }
        }

        return <Paper>
            <Heading>Users</Heading>
            <SearchBar
                onEvent={(event, defaultHandler) => {
                    if (event.type === 'INPUT_CHANGE') {
                        let input = event.input;
                        if (input && input.length >= 3) {
                            this.setState({searchStatus: 'loading', currentSearch: event.input})
                            searchUsers({query: event.input}).then(res => {
                                if (input === this.state.currentSearch) {
                                    this.setState({users: res.users, searchStatus: 'success'});
                                }
                            }).catch(e => {
                                if (input === this.state.currentSearch) {
                                    this.setState({users: undefined, searchStatus: 'failure'});
                                }
                            });
                        }
                    }
                }}
                wildCardSearchEnabled={false}
                suggestionsState={this.state.searchStatus || 'initial'}
                suggestions={undefined}
            />

            <Table
                columns={columns}
                dataSource={dataSource}
                idProperty="id"
                rowHeight="compact"
                showColumnMenuTool={false}
                loading={this.state.searchStatus === 'loading'}
                style={{ width: '100%', height: '400px' }}
            />

        </Paper>
    }
}
